"use client";

import { SubmitQuestion as SubmitQuestionType } from "@/commonTypes/question";
import { useTranslations } from "next-intl";

export interface SubmitQuestionProps {
  question: SubmitQuestionType;
}

export default function SubmitQuestion({ question }: SubmitQuestionProps) {
  const t = useTranslations();

  const { questionTranslationKey, bodyTextTranslationKey } = question;
  const questionText = t(questionTranslationKey);
  const bodyText = t(bodyTextTranslationKey);
  const disclaimerText = t.rich("questions.submit.disclaimer", {
    bold: (chunks) => <strong>{chunks}</strong>,
  });

  return (
    <div className="question-container submit-question">
      <h1 className="question-title">{questionText}</h1>

      {bodyText && <div>{bodyText}</div>}
      {disclaimerText && (
        <p className="submit-question-disclaimer">{disclaimerText}</p>
      )}
    </div>
  );
}
